import { getPassportConfig, PASSPORT_INFO_KEY, PASSPORT_JS_URL } from '@/config/passport/config'
import storage from '@didi/didi-store'
import { postForm } from '@/utils/request'
import { getLanguage, getLocale, getRegion } from '@/utils/common/locale'
import { getQueryObj } from '@/utils/common/query'
import PACKAGE_JSON from '../../../package'

let loginJs = null

/**
 * @name 获取当前国家，默认取query，query没有从地址栏取国家码
 * @return {string} country
 */
function getCountry() {
  const query = getQueryObj()
  return query.country || getRegion()
}

function getLoginJs() {
  if (loginJs) {
    return loginJs
  } else {
    loginJs = new Promise(resolve => {
      const script = document.createElement('script')
      const passportUrl = PASSPORT_JS_URL.ONLINE
      script.src = passportUrl
      document.body.appendChild(script)
      script.onload = async function () {
        const passportConfig = getPassportConfig(getCountry())
        window.login.setConfig(passportConfig)
        resolve(window.login)
      }
      script.onerror = function () {
        console.log('passport error')
      }
    })
    return loginJs
  }
}

// 登陆相关
export default {
  // 强制登陆
  async forceLogin(callFn) {
    getLoginJs().then(login => {
      login.forceLogin(
        res => {
          callFn && callFn()
          storage.set(PASSPORT_INFO_KEY, res)
          window.location.reload()
        },
        err => {
          console.log('passport login error', err)
        },
      )
    })
  },
  // 登出
  async goToLogout() {
    storage.remove(PASSPORT_INFO_KEY)
    this.forceLogin()
  },
}
// 判断是否在passport登陆链接白名单内
export function isWhiteNameForShare() {
  const pathName = window ? window.location.pathname : ''
  const whiteNameForShareArr = [
    '/shareDiagnosis',
    '/confirmation-entrega',
    '/delivery-worker-verify',
  ]
  return whiteNameForShareArr.some(item => {
    return pathName.indexOf(item) > -1
  })
}

// 登陆时获取必需的主体信息
export function getContractor() {
  return postForm('/auth/getContractor', {})
}
// 登陆时获取必需的门店信息
export function getShopByID() {
  return postForm('/auth/getShopByID', {})
}
// 获取设备类型
export function getOSInfo() {
  const userAgent = navigator.userAgent
  if (/win/i.test(userAgent)) return 'window'
  if (/mac/i.test(userAgent)) return 'mac'
  if (/Android/i.test(userAgent)) return 'android'
  if (/iphone|ipad|ipod|ios/i.test(userAgent)) return 'ios'
}
export const OS_TYPE_JSON = {
  window: 9,
  mac: 10,
  android: 2,
  ios: 1,
  default: -1,
}

/**
 * @name 获取全局公共参数
 * @returns globalParams
 */

export function getDefaultGlobalParams(globalParams = {}) {
  const version = PACKAGE_JSON.version.split('-')[0]
  const loginInfo = storage.get(PASSPORT_INFO_KEY) || {}
  const defaultGlobalParams = {
    shopId: '',
    contractorId: '',
    cityId: '',
    appVersion: version,
    versionCode: version,
    webVersion: version, // h5版本号
    clientType: '3', // 1:R, 2:国内嵌入端C, 3:B, 4:BD，5:国内独立端C )，6：国际化独立端C ，7：国际嵌入式C，8：99独立端C ，9：99嵌入端C
    bizId: '380', // 待确认
    osVersion: 'web', // 待确认
    osType: OS_TYPE_JSON[getOSInfo() || 'default'], // 1:iOS, 2:android, 3:web 9: windowsPC
    originType: '1', // 1app 2pad 3web 4exe
    terminalType: '5', // 端类型信息 app 1： 独立端 2：嵌入式 3 : pad 4 : exe 5: web 6: 轻应用 miniProgram7 : 支付宝8 :微信
    businessType: '3', // 内部业务类型 1:r, 2:c, 3:b, 4:bd, 5:m
    locale: getLocale(),
    lang: getLanguage().long,
    countryCode: '',
    token: loginInfo?.ticket,
    uid: loginInfo?.uid,
  }
  return {
    ...defaultGlobalParams,
    ...globalParams,
  }
}
